// extracted by mini-css-extract-plugin
export var container = "ShipDeckPlanSection-module--container--df677";
export var cta = "ShipDeckPlanSection-module--cta--3464f";
export var description = "ShipDeckPlanSection-module--description--557fe";
export var image = "ShipDeckPlanSection-module--image--4f087";
export var techData = "ShipDeckPlanSection-module--techData--d0e74";
export var techDataItem = "ShipDeckPlanSection-module--techDataItem--6f3cc";
export var title = "ShipDeckPlanSection-module--title--96140";